import { jsx as _jsx } from "react/jsx-runtime";
const TWITTER_USER_ID = "912574397076123648";
export const getTwitterMetaTags = ({ title, description, imagePath = "https://s3.amazonaws.com/general-assets/monday-800x418.png" })=>{
    return [
        /*#__PURE__*/ _jsx("meta", {
            name: "twitter:card",
            content: "summary"
        }),
        /*#__PURE__*/ _jsx("meta", {
            name: "twitter:site",
            content: "@mondaydotcom"
        }),
        /*#__PURE__*/ _jsx("meta", {
            name: "twitter:title",
            content: title
        }),
        /*#__PURE__*/ _jsx("meta", {
            name: "twitter:description",
            content: description
        }),
        /*#__PURE__*/ _jsx("meta", {
            name: "twitter:image",
            content: imagePath
        }),
        /*#__PURE__*/ _jsx("meta", {
            property: "twitter:account_id",
            content: TWITTER_USER_ID
        })
    ];
};
